import api from '../../../store/api';
export const cvApi = {
  list: (context = {}) => api.get('/config/curriculums', { params: context }).then(r => r.data),
  get: (id, context = {}) => api.get(`/config/curriculums/${id}`, { params: context }).then(r => r.data),
  command: command => api.post('/config/curriculums/transactions', command).then(r => r.data),
  create: (name, data, extras = {}) => cvApi.command({
    action: 'create',
    requestId: crypto.randomUUID(),
    name,
    data,
    ...extras
  }),
  edit: (id, section, changes, revision) => cvApi.command({
    action: section,
    input: {
      requestId: crypto.randomUUID(),
      cvId: id,
      expectedRevision: revision,
      ...(['personalInfo', 'introduction'].includes(section) ? {
        changes
      } : {
        operation: 'replace',
        items: changes
      })
    }
  })
};
export const CV_STORAGE_KEY = 'cvDataStorage';
export const emptyCv = () => ({
  personalInfo: {
    name: '',
    phone: '',
    email: '',
    linkedin: '',
    github: '',
    city: ''
  },
  introduction: '',
  education: [],
  experience: [],
  research: [],
  skills: [],
  areasOfSpecialization: [],
  courses: [],
  languages: []
});
export const cvError = error => error.response?.data?.message || error.message || 'No se pudo guardar el currículum';
